import React from 'react'
import Stack from '@mui/material/Stack'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { endOfDay, endOfMonth, isAfter, isBefore, startOfDay, startOfMonth } from 'date-fns'
import { sv } from 'date-fns/locale'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import useMediaQuery from '@mui/material/useMediaQuery'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { TextFieldProps } from '@mui/material/TextField'
import { DateView } from '@mui/x-date-pickers/models'

const DATE_VIEWS: DateView[] = ['year', 'month', 'day']

export const SelectDateRange = ({
    granularity = 'month',
    minDate,
    onChange,
    size,
    values,
}: {
    granularity?: DateView
    minDate?: string
    onChange: (values: [Date | undefined, Date | undefined]) => void
    size?: TextFieldProps['size']
    values: [Date | undefined, Date | undefined]
}) => {
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const dateViews = DATE_VIEWS.slice(0, DATE_VIEWS.findIndex((v) => v === granularity) + 1)
    const dateFormat = granularity === 'month' ? 'MMM yy' : 'dd MMM yy'

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={sv}>
            <Stack direction='row' spacing={1} sx={isSmallScreen ? { maxWidth: `calc(100vw - 24px)` } : null}>
                <DatePicker
                    label='Tidsperiod start'
                    views={dateViews}
                    format={dateFormat}
                    minDate={minDate ? startOfMonth(new Date(minDate)) : undefined}
                    maxDate={values[1]}
                    value={values[0]}
                    onChange={(newValue) => {
                        if (newValue) {
                            const nv = granularity === 'month' ? startOfMonth(newValue) : startOfDay(newValue)

                            if (!values[1] || isBefore(nv, values[1])) {
                                onChange([nv, values[1]])
                            }
                        }
                    }}
                    slotProps={{
                        textField: { size },
                    }}
                    sx={{
                        '& .MuiButtonBase-root': {
                            paddingLeft: 0,
                        },
                    }}
                />
                <Box
                    sx={{
                        alignContent: 'center',
                    }}
                >
                    -
                </Box>
                <DatePicker
                    label='Tidsperiod slut'
                    views={dateViews}
                    format={dateFormat}
                    minDate={values[0]}
                    maxDate={endOfMonth(new Date())}
                    value={values[1]}
                    onChange={(newValue) => {
                        if (newValue) {
                            const nv = granularity === 'month' ? endOfMonth(newValue) : endOfDay(newValue)
                            if (!values[0] || isAfter(nv, values[0])) {
                                onChange([values[0], nv])
                            }
                        }
                    }}
                    slotProps={{
                        textField: { size },
                    }}
                    sx={{
                        '& .MuiButtonBase-root': {
                            paddingLeft: 0,
                        },
                    }}
                />
            </Stack>
        </LocalizationProvider>
    )
}
